import { Link } from 'react-router-dom';

export const homeFaqs = [
  {
    q: 'What exactly is Vigorbuy Spreadsheet?',
    a: 'Vigorbuy Spreadsheet is an organized product discovery resource that helps users find and compare products across multiple categories. It structures product information in an easy-to-navigate format, making online shopping research faster and more efficient than traditional browsing methods.',
  },
  {
    q: 'Is Vigorbuy Spreadsheet free to use?',
    a: 'Yes, Vigorbuy Spreadsheet provides free educational resources and product discovery tools. Users can browse categories, read guides, and access comparison information without any cost. For actual product purchases, users are directed to the main website.',
  },
  {
    q: 'How often is the product database updated?',
    a: 'The product database behind Vigorbuy Spreadsheet is regularly updated to reflect the latest available products, categories, and information. This ensures users always have access to current product data when making shopping decisions.',
  },
  {
    q: 'Can I find products from all categories in one place?',
    a: 'Absolutely. One of the core advantages of Vigorbuy Spreadsheet is that it organizes products from numerous categories — including Shoes, Hoodies, T-Shirts, Jackets, Accessories, Bags, and more — all within a single, structured resource.',
  },
  {
    q: 'Is my personal information safe when using Vigorbuy Spreadsheet?',
    a: 'Vigorbuyspread.autos is an independent informational website. We do not process payments or collect personal shopping data. When you click through to external product pages, we recommend reviewing the privacy policy of the destination website before making any purchase.',
  },
  {
    q: 'How do I get started with Vigorbuy Spreadsheet?',
    a: 'Getting started is simple. Browse our product categories using the dropdown menu or category buttons on this page, select the category that interests you, and you will be directed to the organized product listings. For a more detailed walkthrough, check out our complete beginner guide.',
  },
];

export default function FaqSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50" id="faq">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-3">
              Frequently Asked Questions
            </h2>
            <p className="text-foreground-600 text-sm md:text-base">
              Everything you need to know about Vigorbuy Spreadsheet and how it helps you shop smarter.
            </p>
          </div>

          <div className="space-y-3">
            {homeFaqs.map((faq, idx) => (
              <details key={idx} className="group bg-background-100 rounded-lg border border-background-200/70 overflow-hidden">
                <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                  <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">{faq.q}</span>
                  <span className="flex-shrink-0 text-foreground-400 group-open:rotate-180 transition-transform duration-200">
                    <i className="ri-arrow-down-s-line text-lg"></i>
                  </span>
                </summary>
                <div className="px-5 pb-4">
                  <p className="text-foreground-600 text-sm leading-relaxed">{faq.a}</p>
                </div>
              </details>
            ))}
          </div>

          <div className="mt-10 text-center">
            <p className="text-foreground-500 text-xs mb-2">
              Still have questions? Visit our complete guide for more detailed information.
            </p>
            <Link
              to="/article/vigorbuy-spreadsheet-guide"
              className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              View Complete Guide
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}